import type { ClientMessage } from '@/types/bindings/ClientMessage';
import { getMetrics } from './metrics';
import { ErrorLocation, reportClientError } from './errors';

const HEARTBEAT_INTERVAL_MS = 30_000;

type SendFn = (msg: ClientMessage) => boolean;

let intervalId: ReturnType<typeof setInterval> | null = null;
let sequenceCounter = 0;
const inflightPings = new Map<number, number>();

export function startHeartbeat(send: SendFn): void {
  stopHeartbeat();
  intervalId = setInterval(() => {
    try {
      sequenceCounter += 1;
      const sequence_number = sequenceCounter;
      const timestamp = Date.now();
      inflightPings.set(sequence_number, timestamp);
      send({ Ping: { sequence_number, timestamp } });
    } catch (err) {
      reportClientError(err, ErrorLocation.HeartbeatFailed);
    }
  }, HEARTBEAT_INTERVAL_MS);
}

export function stopHeartbeat(): void {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  inflightPings.clear();
}

export function recordPongRtt(sequenceNumber: number): void {
  try {
    const sendTime = inflightPings.get(sequenceNumber);
    if (typeof sendTime !== 'number') return;
    inflightPings.delete(sequenceNumber);
    getMetrics().wsPingRttMs.record(Date.now() - sendTime);
  } catch (err) {
    reportClientError(err, ErrorLocation.HeartbeatFailed);
  }
}

export function _resetHeartbeatForTests(): void {
  stopHeartbeat();
  sequenceCounter = 0;
}
